import styled from "styled-components";
import { ImageSlide } from "@sonder/ui/source/styled/fragments/ImageSlide";
import { VideoPlayerSlide } from "@sonder/ui/source/styled/fragments/VideoPlayerSlide";

export const ImageGallery = styled.div`
  display: flex;
  flex-wrap: nowrap;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;

  > ${ImageSlide}, > ${VideoPlayerSlide} {
    &:not(:last-child) {
      margin-right: 1.5rem;
    }
  }
`;
